// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14aIh","title":"Header_title__np5Fj","left":"Header_left__geqqT","clinicName":"Header_clinicName__2YzhZ"};